import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Hero from "../sections/Hero";
import OipContainer from "../sections/OipContainer";
import PassageContainer from "../sections/PassageContainer";
import Image from "../components/Image";

gsap.registerPlugin(ScrollTrigger);

function PageContainer() {
  return (
    <div id="scroll-container">
      <div className=" hero w-full h-[200vh]">
        <Hero></Hero>
      </div>
      <div className="relative z-10 h-[1100vh]">
        <div className="oip w-full h-screen sticky flex justify-center items-center bg-[#354456] z-10 top-0 left-0">
          <OipContainer />
        </div>
      </div>
      <div className="passage-ui w-full h-[2200vh]">
        <div className="sticky top-0 w-full h-screen">
          <Image
            containerCss={"w-full top-0 left-0"}
            src="https://res.cloudinary.com/dl5mqatis/image/upload/v1648051097/passage/passage-showcase/Group_762-min_atipui.png"
          />
          <div className="passage w-full flex justify-center items-center h-screen absolute z-20 top-0 left-0">
            <PassageContainer />
          </div>
          <Image
            containerCss={"w-full absolute bottom-0 rotate-180 left-0"}
            src="https://res.cloudinary.com/dl5mqatis/image/upload/v1648051097/passage/passage-showcase/Group_762-min_atipui.png"
          />
        </div>
      </div>
    </div>
  );
}

export default PageContainer;
